module.exports = __webpack_public_path__ + "static/media/pic05.d858c954.svg";